<template>
  <div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <!-- Credentials -->
                <CRow>
                    <!-- Username -->
                    <CCol class="d-flex flex-column justify-content-between" sm="6">
                        <CInput v-if="basePerson" class="mb-0" type="text" label="Nome de utilizador" placeholder="" v-model="person.username" :disabled="true"/>
                        <CInput v-if="person.password != null" class="mb-0" type="text" label="Palavra-passe" placeholder="" v-model="person.password" :is-valid="passwordValidator"/>
                    </CCol>
                    <!-- Credentials -->
                    <CCol class="d-flex justify-content-end align-self-end" sm="6">
                        <div v-if="person.password == null" class="d-flex flex-column align-items-end" style="">
                            <CButton color="primary" variant="outline" square size="sm" @click="generateCredentials">
                                Gerar credenciais
                            </CButton>
                            <p class="requested-password" v-if="person.requestPassword">Este utilizador solicitou o envio de novas credenciais</p>
                        </div>
                        <CRow v-else>
                            <CCol id="download-qr-code" class="mr-2 d-flex flex-column justify-content">
                                <label>Acesso por Código QR</label> 
                                <CButton id="download-qr-code-button" color="primary" variant="outline" square size="sm" @click="downloadTapped">
                                    Descarregar código QR
                                </CButton>
                            </CCol>
                            <VueQrcode id="qr-code" :value="person.accessCode" :options="{ width: 150 }"></VueQrcode>
                        </CRow>
                    </CCol>
                </CRow>
                <hr v-if="basePerson"/>
                <CRow>
                    <!-- Image -->
                    <CCol sm="12" md="5" lg="3">
                        <label class="">Imagem</label>
                        <div title="Choose an image"
                            class="base-image-input"
                            :style="{ 'background-image': `url(${imageData})` }"
                            @click="chooseImage"
                            v-bind:class="{'is-invalid': genericValidator() == false}">
                            <span
                            v-if="!imageData"
                            class="placeholder"
                            >
                            Escolher imagem
                            </span>
                            <input
                            class="file-input"
                            ref="fileInput"
                            type="file"
                            @change="onSelectFile"
                            >
                        </div>
                    </CCol>
                    <CCol sm="12" md="7" lg="9" class="d-flex flex-column justify-content-between">
                        <CRow>
                            <!-- First name -->
                            <CCol sm="6">
                                <CInput class="mb-0" label="Nome*" placeholder="" v-model="person.firstName" :is-valid="textValidator(person.firstName)"/>
                            </CCol>
                            <!-- Hourly pay -->
                            <CCol sm="6">
                                <CInput class="mb-0" label="Apelido" placeholder="" v-model="person.lastName" :is-valid="genericValidator"/>
                            </CCol>
                        </CRow>
                        <!-- Role -->
                        <CInput sm="12" class="mb-0" label="Cargo" placeholder="" v-model="person.role" :is-valid="genericValidator"/>
                        <CRow>
                            <!-- Telephone -->
                            <CCol sm="6">
                                <CInput class="mb-0" type="number" label="Telefone" placeholder="" v-model="person.telephone" :is-valid="genericValidator"/>
                            </CCol>
                            <!-- Hourly pay -->
                            <CCol sm="6">
                                <CInput class="mb-0" type="number" label="Valor hora*" placeholder="" v-model="person.hourlyRating" :is-valid="textValidator(person.hourlyRating)"/>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <!-- Notes -->
                <CRow class="mt-3">
                    <CCol sm="12">
                        <CTextarea label="Notas" placeholder="" vertical v-model="person.notes" rows="3"/>
                    </CCol>
                </CRow>
                <!-- Alerts -->
                <hr v-if="basePerson"/>
                <CRow>
                    <CCol sm="6">
                        <label class="">Alertas</label>
                    </CCol>
                    <CCol v-if="!hasNewAlert" class="d-flex justify-content-end pr-1" sm="6">
                        <CButton class="mr-2" color="primary" variant="outline" square size="sm" @click="newAlertTapped">
                        Adicionar alerta
                        </CButton>
                    </CCol>
                </CRow>
                <CRow v-for="alert in alerts" :key="alert.id" v-bind:class="{'remove-alert': alertsRemoveIds.includes(alert.id)}" class="d-flex justify-content-between mb-1 mt-1">
                    <CCol sm="9" class="d-flex align-items-center">
                        <span class="alert-text" v-bind:class="{'show-all': shownAlert == alert}">{{alert.text}}</span>
                    </CCol>
                    <CCol sm="3" class="d-flex justify-content-end button-container">
                        <CButton v-if="!alertsRemoveIds.includes(alert.id)" class="mr-1" color="primary" variant="outline" square size="sm" @click="onToggleSeeClicked(alert)">
                            {{ shownAlert == alert ? "Ver menos" : "Ver mais" }}
                        </CButton>
                        <CButton v-if="!alertsRemoveIds.includes(alert.id)" class="ml-1" color="primary" variant="outline" square size="sm" @click="onRemoveClicked(alert)">
                            Remover
                        </CButton>
                        <CButton v-else class="ml-1" color="primary" variant="outline" square size="sm" @click="onCancelRemoveClicked(alert)">
                            Adicionar
                        </CButton>
                    </CCol>
                </CRow>
                <!-- Action button -->
                <CCol class="d-flex justify-content-end mt-3">
                    <CRow sm="2" class="align-self-end">
                        <CSpinner v-if="loading" variant="success" small></CSpinner>
                        <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">Submeter</CButton>
                    </CRow>
                </CCol>
            </CCardBody>
        </CCard>
    </CCol>
    <AddAlertModal v-if="showAlertModal" v-model="showAlertModal" @ok-tapped="addAlertOkTapped" @cancel-tapped="addAlertCancelTapped"></AddAlertModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Person from "@/classes/Person";
import InputPerson from "@/classes/InputPerson";
import InputCredentials from "@/classes/InputCredentials";
import InputMessage from "@/classes/InputMessage";
import { UTILS_HELPER } from "@/helpers/utils.js";
import AddAlertModal from '../controls/AddAlertModal.vue'
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
    components: { AddAlertModal, VueQrcode },
    props:{    
        basePerson:
        {
            type: Object,
            default: null
        }
    },
    data()
    {
        return {
            imageData: '', // The direct binding to person.path was not working correctly
            submitted: false,
            person: new Person(),
            loading: false,
            shownAlert: null,
            showAlertModal: false,
            alerts: [],
            alertsRemoveIds: []
        }
    },
    mounted: function()
    {
        this.resetPerson();

        // In case of edit, get messages
        if(this.$route.params.id)
        {
            this.getMessages();
        }
        // In case it is a new user, generate credentaisl
        // If it is an edit, this will only be accessible by tapping a button
        else
        {
            this.generateCredentials();
        }
    },
    computed:
    {
        ...mapState('alert', ['type']),
        ...mapState('alert', ['message']),
        ...mapState({
            messagesListOutput: state => state.messages.listOutput,
        }),
        hasNewAlert: function()
        {
            return this.alerts.filter(alert => alert.id === 0).length > 0;
        },
    },
    methods:{
        ...mapActions({
            'getMessages': 'messages/getList',
        }),
        ...mapActions('messages', ['addMessage']),
        ...mapActions('messages', ['removeMessages']),
        chooseImage () 
        {
            this.$refs.fileInput.click();
        },   
        onSelectFile () 
        {
            const input = this.$refs.fileInput;
            const files = input.files;
            if (files && files[0]) {
                const reader = new FileReader();
                reader.onload = e => 
                {
                    this.imageData = e.target.result;
                }
                reader.readAsDataURL(files[0]);
            }
        },
        resetPerson()
        {
            if(!this.basePerson)
            {
                this.person = new Person();
            }
            else
            {
                this.person = UTILS_HELPER.deepClone(new Person, this.basePerson);
            }

            this.imageData = this.person.photoPath;
        },
        submitClicked()
        {
            this.submitted = true;

            // Emit event
            if(this.person.isValid())
            {
                // Build object
                var inputPerson = new InputPerson(null, this.person, this.$refs.fileInput.files[0]);
                var inputCredentials;
                var inputMessage;

                if(this.$route.params.id)
                {
                    inputPerson.id = this.$route.params.id;

                    if(this.person.password)
                    {
                        inputCredentials = new InputCredentials(this.$route.params.id, this.person.password, this.person.accessCode);
                    }

                    if(this.hasNewAlert)
                    {
                        var text = this.alerts.find(alert => alert.id == 0).text;
                        inputMessage = new InputMessage(text, this.$route.params.id);
                    }
                }

                this.loading = true;
                this.$emit('submit-requested', inputPerson, inputCredentials, inputMessage, this.alertsRemoveIds);
            }
        },
        genericValidator(){
            var result = undefined; // This is the default, in case the user hasn't submitted yet

            // Validate error
            if(this.submitted && this.addError)
            {
                result = false;
            }

            return result;
        },
        textValidator(val){
            var result = this.genericValidator();

            if(this.submitted && result != false)
            {
                result = Boolean(val);
            }

            return result;
        },
        passwordValidator()
        {
            var result = this.genericValidator();

            if(this.submitted && result != false && this.person.password != null)
            {
                result = this.person.password && this.person.password.length >= 6;
            }

            return result;
        },
        generateCredentials()
        {
            if(this.basePerson)
            {
                alert("Foram geradas novas credenciais. As credenciais atuais serão invalidadas ao confirmar o formulário.");
            }

            // Credentials are generated based on the username and ticks
            var ticks = new Date().getTime().toString();
            var lastTicksDigits = ticks.slice(-2);
            var lastUsernameChars = this.person.username ? this.person.username.slice(-4) : Math.random().toString(36).substr(2, 4);

            this.person.password = UTILS_HELPER.shuffle(lastTicksDigits + lastUsernameChars);
            this.person.accessCode = this.person.username + new Date().getTime();
        },
        onRemoveClicked(alert)
        {
            if(alert.id == 0)
            {
                this.alerts.splice(this.alerts.indexOf(alert), 1);
            }
            else
            {
                this.alertsRemoveIds.push(alert.id);
            }
        },
        onCancelRemoveClicked(alert)
        {
            this.alertsRemoveIds.splice(this.alertsRemoveIds.indexOf(alert.id), 1);
        },
        onToggleSeeClicked(alert)
        {
            if(this.shownAlert == alert)
            {
                this.shownAlert = null;
            }
            else
            {
                this.shownAlert = alert;
            }
        },
        newAlertTapped()
        {
            this.showAlertModal = true;
        },
        addAlertOkTapped(alert)
        {
            this.alerts.push({id: 0, text: alert});
            this.showAlertModal = false;
        },
        addAlertCancelTapped()
        {
            this.showAlertModal = false;
        },
        downloadTapped()
        {
            var image = document.getElementById("qr-code").toDataURL("image/png").replace("image/png", "image/octet-stream");

            let a = document.createElement('a');
            a.href = image;
            a.download = `${this.person.username}.png`;

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    },
    watch:
    {
        basePerson: function(val)
        {
            this.resetPerson();
        },
        type: function()
        {
            this.addError = this.type == "alert-danger" ? this.message : '';
            this.loading = false;
        },
        message: function()
        {
            this.addError = this.type == "alert-danger" ? this.message : '';
            this.loading = false;
        },
        messagesListOutput: function()
        {
            if(this.messagesListOutput && this.messagesListOutput.obj)
            {
                this.alerts = this.messagesListOutput.obj.private.filter(message=> message.userId == this.person.id);
            }
        }
    }
}
</script>

<style>
.base-image-input {
  display: block;
  width: 200px;
  height: 200px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}

.placeholder {
  background: #F0F0F0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: Helvetica;
}

.placeholder:hover {
  background: #E0E0E0;
}

.file-input {
  display: none;
}

img
{
  width: 50%;
  height: 50%;
}

.base-image-input.is-invalid > span
{
  background-color: #e55353;
  color: white;
}

#download-qr-code
{
    justify-content: space-evenly;
}

.remove-alert
{
    background: gray;
    color: white;
}

.remove-alert button
{
    border: none;
    padding-right: 0;
    padding: 0.5rem 0 0.5rem 0rem;
    color: white;
}

.requested-password
{
  background-color: lightgoldenrodyellow;
}
</style>